import React  from "react";
import { useParams } from 'react-router-dom';
import RegisteredAnimalsForm from "../components/AnimalInventoryForm";
import AnimalInventoryTab from "../components/AnimalInventoryTab";
import Card from "components/card";
import { ANIMAL_TYPE_CATTLE } from "variables/constants";

const ViewCattle = () => {
	const { cattleId } = useParams();

	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<RegisteredAnimalsForm recordId={cattleId} mode="view" animalTypeId={ANIMAL_TYPE_CATTLE}/>

				<div className="mt-4 mb-4">
					<Card extra={"w-full h-full p-4"}>
						<AnimalInventoryTab recordId={cattleId}/>
					</Card>
				</div>
	      </div>
	    </div>
    );
};

export default ViewCattle;